import type { ProfileUser } from "../types/profile";
import type { DateValue } from "../types/data";

export interface FriendRequest extends ProfileUser {
  requesterId?: string;
  recipientId?: string;
  requesterName?: string;
  requesterDisplayName?: string;
  requesterPhotoURL?: string;
  requesterAvatarUrl?: string;
  recipientName?: string;
  status?: "pending" | "accepted" | "kept_as_follower" | "dismissed";
}

export const FRIEND_REQUEST_STATUS = Object.freeze({
  pending: "pending",
  accepted: "accepted",
  keptAsFollower: "kept_as_follower",
  dismissed: "dismissed"
});

const normalizeText = (value: unknown) => String(value || "").replace(/\s+/g, " ").trim();

export const getFriendRequestDisplayName = (request: FriendRequest | null = {}) => {
  const data = request || {};
  return normalizeText(
    data.requesterName ||
    data.requesterDisplayName ||
    data.name ||
    data.displayName ||
    "Пользователь"
  );
};

export const buildFriendRequestPayload = ({
  requesterId,
  recipientId,
  requester = {},
  recipient = {},
  timestamp = new Date()
}: {
  requesterId: string; recipientId: string; requester?: ProfileUser;
  recipient?: ProfileUser; timestamp?: DateValue;
}) => {
  const requesterName = normalizeText(
    requester.name ||
    requester.displayName ||
    requester.email?.split?.("@")?.[0] ||
    "Пользователь"
  );
  const recipientName = normalizeText(
    recipient.name ||
    recipient.displayName ||
    recipient.email?.split?.("@")?.[0] ||
    ""
  );

  return {
    requesterId,
    recipientId,
    requesterName,
    requesterDisplayName: normalizeText(requester.displayName || requesterName),
    requesterPhotoURL: normalizeText(requester.photoURL || requester.avatarUrl || ""),
    requesterAvatarUrl: normalizeText(requester.avatarUrl || requester.photoURL || ""),
    recipientName,
    status: FRIEND_REQUEST_STATUS.pending,
    createdAt: timestamp,
    updatedAt: timestamp
  };
};

export const buildFriendDocFromRequest = (request: FriendRequest | null = {}, timestamp: DateValue = new Date()) => {
  const data = request || {};
  const name = getFriendRequestDisplayName(data);

  return {
    uid: data.requesterId,
    name,
    displayName: normalizeText(data.requesterDisplayName || name),
    photoURL: normalizeText(data.requesterPhotoURL || data.requesterAvatarUrl || ""),
    avatarUrl: normalizeText(data.requesterAvatarUrl || data.requesterPhotoURL || ""),
    addedAt: timestamp
  };
};
